export default "__VITE_ASSET__C5Oh$Cp$__"